import journey from './journey';

const journeyReducers = { journey };

export default journeyReducers;

export * from './journey';
